import fr from 'facet-rest';
import TextField from 'Components/ComponentLibrary/Components/Uncategorized/TextField';
import DateField from 'Components/ComponentLibrary/Components/Uncategorized/DateField';
import { monthYear, year } from 'Consts/DateFormats';
import MultiselectField from 'Components/ComponentLibrary/Components/Uncategorized/MultiselectField';
import { DollarNumberFormatUsd } from 'Components/UI/DollarUSDInput';
import { PhoneMaskedTextInput } from 'Components/UI/MaskedInput';
import { moment } from 'Helpers/DateTime';
import RichTextEditor from 'Components/UI/RichTextEditor';
import RichTextDisplay from 'Components/UI/RichTextDisplay';
import BodyTextLarge from 'Components/ComponentLibrary/Atoms/Text/BodyTextLarge';
import HeadlineTextLarge from 'Components/ComponentLibrary/Atoms/Text/HeadlineTextLarge';
import BaseOverride from '../BaseOverride';

export default fr.metaOverride({ base: BaseOverride })
  .typeOverride('number', {
    _component: () => TextField,
  }, { ordinal: 200 })// Apply even if readonly
  .typeOverride('string', {
    _component: () => TextField,
  }, { ordinal: 200 })// Apply even if readonly
  .override({ hint: 'richtext' }, {
    _component: () => RichTextEditor,
  }, { ordinal: 200 })
  .override({ hint: 'richtext', readonly: true },
    { _component: () => RichTextDisplay },
    { ordinal: 200 })
  .override({ hint: 'year' }, {
    _component: () => DateField,
    _customProps: {
      openTo: 'year',
      views: ['year'],
      format: year,
      placeholder: year,
    },
    _transformValue: () => (v) => {
      if (!v) {
        return '';
      }
      return moment(v).format(year);
    },
  }, { ordinal: 200 })
  .typeOverride('multipicklist', {
    _component: () => MultiselectField,
    _customProps: {},
  })
  .override({ hint: 'phoneNumber' }, {
    _component: () => TextField,
    _customProps: {
      InputProps: {
        inputComponent: PhoneMaskedTextInput,
      },
    },
  })
  .override({ hint: 'usd' }, {
    _customProps: {
      InputProps: {
        // TODO: Figure out if we can make this the default across the app
        inputComponent: DollarNumberFormatUsd,
      },
    },
  }, { ordinal: 100 })
  .typeOverride('date', {
    _customProps: {
      openTo: 'year',
      views: ['year', 'month'],
      format: monthYear,
      placeholder: monthYear,
    },
    _component: () => DateField,
    _transformValue: () => (v) => {
      if (!v) {
        return '';
      }
      return moment(v).utc().startOf('month').toISOString();
    },
  })
  .override({ type: 'number', readonly: true }, {
    _component: () => TextField,
    _customProps: {
      InputProps: {
        inputComponent: undefined,
      },
    },
  }, { ordinal: 200 })
  .override({ type: 'string', readonly: true }, {
    _component: () => TextField,
    _customProps: {
      InputProps: {
        inputComponent: undefined,
      },
    },
  }, { ordinal: 200 })
  .override({ type: 'picklist', readonly: true }, {
    _component: () => TextField,
    _customProps: {
      InputProps: {
        inputComponent: undefined,
      },
    },
  }, { ordinal: 200 })
  .override({ type: 'date', readonly: true }, {
    _component: () => TextField,
    _customProps: {
      InputProps: {
        inputComponent: undefined,
      },
    },
  }, { ordinal: 200 })
  .nameOverride('outcomeName', {
    _component: () => HeadlineTextLarge,
    hidden: false,
  }, { ordinal: 200 })
  .nameOverride('title', {
    _component: () => HeadlineTextLarge,
    hidden: false,
  }, { ordinal: 200 })
  .nameOverride('subtitle', {
    _component: () => BodyTextLarge,
    hidden: false,
  }, { ordinal: 200 })
  .overrideAll({
    _customHelperProps: {
      showRequiredHelperText: true,
    },
  })
  .override({ readonly: true }, { hidden: false })
  .done();
